<div id="nav-header" class="nav-header header header-md"  [class.nav-header--no-search]="!displaySearchBar()">
  <div class="nav-navbar-container">
    <div id="nav-navbar" class="nav-navbar">
      <div class="nav__titlebar">
        @if (navService.showBackButton && !this.navService.showSearchbar) {
          <button (click)="navService.goBack()"
            class="bar-button bar-button-md back-button-md bar-button-default bar-button-default-md top-back-button">
            <img src="/assets/img/arrow_back.svg" alt="Back" height="30px" width="32px">
            <div class="button-effect"></div>
          </button>
        }
        @if (clientBrandingService.logoUrl() && this.showLogo()) {
          <rdo-logo [url]="clientBrandingService.logoUrl()" />
        }
        <div id="title" class="nav__titlebar-content" [ngClass]="{'nav__titlebar-content--logo-present': clientBrandingService.logoUrl() && this.showLogo()}" >
          <div class="nav__title" [innerHTML]="navService.pageTitle"></div>
        </div>
      </div>
    </div>
  </div>
  @if (displaySearchBar()) {
    <div id="nav-searchbar" class="searchbar searchbar-md searchbar-left-aligned button-clear-md-dar"
      [ngClass]="getSearchbarHasFocus()">
      @if (navService.showBackButton) {
        <button (click)="navService.goBack()"
          class="bar-button bar-button-md back-button-md bar-button-default bar-button-default-md" style="vertical-align:middle">
          <img src="/assets/img/arrow_back.svg" alt="Back" height="30px" width="32px">
          <div class="button-effect"></div>
        </button>
      }
      <div class="searchbar-input-container"><button
        class="searchbar-md-cancel button button-md button-clear button-clear-md button-clear-md-dar" clear=""
        color="dark" ion-button="" mode="md" type="button"><span class="button-inner">
        <img name="app-icon md-arrow-back" role="img" class="icon icon-md ion-md-arrow-back"
          aria-label="arrow back" />
      </span>
      <div class="button-effect"></div>
    </button>
    <div class="searchbar-search-icon nav__search-icon"></div>
    <input class="searchbar-input nav__searchbar-input" dir="auto"
      placeholder="{{searchPlaceholderText}}" type="search" autocomplete="off" autocorrect="off"
      spellcheck="false" (keyup)="onSearchInput($event)" #searchInput />
    <button class="searchbar-clear-icon button button-md button-clear button-clear-md"
      type="button" (click)="clearSearchText()">
      <span class="button-inner"></span>
      <div class="button-effect"></div>
    </button>
  </div>
  <button class="button-md-cancel" [hidden]="!pageHasSearchResults()"
    type="button" tabindex="-1" (click)="clearSearchResults()">
    <span class="button-inner">{{getLabelTranslation('Cancel')}}</span>
    <div class="button-effect"></div>
  </button>
</div>
}
@if (showFilterBar()) {
  <div class="bottom-padding-5">
    @if (selectedCustomers.length > 0) {
      <div class="customer-button" (click)="clearCustomerSelections()">
        <span style="padding: 16px;"><span style="padding-right: 3px">
          <img src="/assets/img/close-circle.svg" class="md hydrated" style="height: 13px;width:13px"/>
        </span>{{getCustomerFilterText()}}</span>
      </div>
    }
  </div>
}
</div>
